// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e74e56ae","633":"651eac97"}[chunkId] + ".chunk.js";
};